/* eslint-disable no-nested-ternary */
import { func } from "prop-types";
import React from "react";
import { connect } from "react-redux";

import {
  driverAssessmentPassed,
  driverAssessmentSubmitted,
} from "../../../redux/actions/formActions";
import AssessmentCreator from "../../../common/AssessmentCreator";

const listQuestion = (
  questionTitle,
  listItems,
  subQuestion = "",
  oneCol = false
) => {
  return (
    <div>
      <h4> {questionTitle} </h4>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: oneCol ? "1fr" : "1fr 1fr",
          width: "80%",
        }}
      >
        {listItems.map((cur) => (
          <h4 key={cur}>{cur}</h4>
        ))}
      </div>
      {subQuestion ? <h4>{subQuestion}</h4> : null}
    </div>
  );
};

const questions = [
  {
    sectionTitle: "Section 1 – Drivers’ Hours and Working Time",
    sectionSubText: "This section has 12 questions.",
  },
  {
    question:
      "A driver commences work at 07:00 and carries out a walk around check of the vehicle which takes 20 minutes. The driver now drives until 10:00 when they stop for 10 minutes to check the security of the load and then recommences driving. Under EU Drivers’ Hours rules what is the latest time the driver must stop to take a statutory break from driving?",
    A: "11:00",
    B: "11:30",
    C: "12:00",
    D: "12:30",
  },
  {
    question:
      "What is the maximum number of hours that can be driven under EU rules in any two consecutive weeks?",
    A: "60 hours",
    B: "90 hours",
    C: "96 hours",
    D: "112 hours",
  },
  {
    question:
      "This is a schedule for a single driver day, with the driver working under EU Rules; does this count as a ‘regular’ or ‘reduced’ daily rest period?",
    A: "A regular daily rest period as 11 hours taken between shifts",
    B: "A reduced rest period which the driver can take on two occasions in a week",
    C: "A regular rest providing the driver makes a note on the tachograph record",
    D: "A reduced rest which the driver can take on up to three occasions between weekly rests",
    imgSrc: "../../../../images/driving_assessments/driver_Q3.PNG",
    largeImage: true,
  },
  {
    question:
      "Which of the following defines a ‘fixed week’ under the EU Drivers’ Hours Regulations?",
    A: "00:00hrs Monday to 24:00 the following Sunday",
    B: "00:00hrs Sunday to 24:00 the following Sunday",
    C: "24:00hrs Sunday to 00:00 the following Monday",
    D: "24:00 hrs Saturday to 00:00 the following Sunday",
  },
  {
    question:
      "A driver subject to the EU Drivers’ Hours rules may a work a maximum of how many days between weekly rest periods?",
    A: "5 days",
    B: "6 days",
    C: "7 days",
    D: "8 days",
  },
  {
    question:
      "Under the Road Transport (Working Time) Regulations a driver may not work more than how many hours without a break?",
    A: "4 hours 30mins",
    B: "5 hours",
    C: "5 hours 30mins",
    D: "6 hours",
  },
  {
    customQuestionComponent: listQuestion(
      "The following activities were recorded by a driver subject to EU Drivers’ Hours rules during a shift.",
      [
        "Driver – 6 hours",
        "Break – 45 minutes",
        "Other Work – 2 hours",
        "Period of Availability – 1 hour",
      ],
      "How much of this shift counts as ‘working time’?"
    ),
    A: "9 hours 45 minutes",
    B: "9 hours",
    C: "8 hours 45 minutes",
    D: "8 hours",
  },
  {
    question:
      "Under the Road Transport (Working Time) Regulations a driver may work a maximum of how many hours in a week?",
    A: "60 hours",
    B: "56 hours",
    C: "48 hours",
    D: "45 hours",
  },
  {
    question:
      "A driver subject to the Road Transport (Working Time) Regulations must not exceed an average of how many hours worked over a reference period?",
    A: "45 hours",
    B: "48 hours",
    C: "60 hours",
    D: "90 hours",
  },
  {
    question:
      "Under the Road Transport (Working Time) Regulations, if a driver’s work activities total more than nine hours in a shift, then breaks totalling how long must be recorded? ",
    A: "15 minutes",
    B: "30 minutes",
    C: "45 minutes",
    D: "60 minutes",
  },
  {
    question:
      "Drivers must allow operators to download data from their driver’s tachograph card at least:",
    A: "Every 28 days",
    B: "Every 30 days",
    C: "Every 45 days",
    D: "Every 90 days",
  },
  {
    question:
      "Unless able to claim an exemption or derogation from the EU Drivers’ Hours Regulations what is the weight threshold that brings vehicles into scope of these regulations?",
    A: "12,000kgs gross vehicle weight or combination weight",
    B: "7,500kgs gross vehicle weight or combination weight",
    C: "5,000kgs gross vehicle weight or combination weight",
    D: "3,500kgs gross vehicle weight or combination weight",
  },
  {
    sectionTitle: "Section 2 - General",
    sectionSubText: "This section has 18 questions.",
  },
  {
    customQuestionComponent: listQuestion(
      "Which of the following defects could attract a PG prohibition?",
      [
        "1 Tyre below minimum legal tread depth",
        "2 Wipers and washers not functioning",
        "3 Horn not working",
        "4 Sharp edges on a damaged front bumper",
      ],
      "",
      true
    ),
    A: "1 and 2 only",
    B: "1, 3 and 4 only",
    C: "2, 3 and 4 only",
    D: "All of them",
  },
  {
    question:
      "Who is responsible for the condition of the vehicle on the public highway and could face prosecution if the vehicle is found to be in an unroadworthy condition?",
    A: "The operator and driver",
    B: "The operator only",
    C: "The driver only",
    D: "The maintenance provider",
  },
  {
    question:
      "If the driver believes the vehicle has already been checked and driven that day, the driver should:",
    A: "Not carry out a vehicle check as its already been done",
    B: "Carry out a routine check of your own anyway",
    C: "Ask to see the previous vehicle check sheet",
    D: "Carry out a routine check if you have time",
  },
  {
    question:
      "Drivers should always confirm with the operator that the route for their vehicle has been checked with the relevant highway or road authorities when their vehicle is over what height?",
    A: "16’ -3” (4.95 metres)",
    B: "16’ (4.88 metres)",
    C: "15’ -6” (4.72 meters)",
    D: "15’ (4.57 metres)",
  },
  {
    question:
      "Whilst a vehicle is being driven on the road, a pallet on the vehicle collapses and the load stacked on the pallet falls to the ground. Which one of the following statements is correct?",
    A: "As the driver had no knowledge of the defective pallet – no offence has been committed",
    B: "The person responsible for loading the vehicle is responsible and committed an offence",
    C: "The operator has committed the offence of using a vehicle with an insecure load",
    D: "There is no admissible defence for using a vehicle with an insecure load",
  },
  {
    question:
      "Why is it important to distribute the weight evenly over the axles when loading a vehicle?",
    A: "To ensure easy unloading",
    B: "To make it easier to sheet",
    C: "To ensure maximum ground clearance",
    D: "To ensure maximum stability",
  },
  {
    question:
      "A driver has category C entitlement on their driving licence. What is the maximum weight of trailer which can be towed under this entitlement?",
    A: "750kgs maximum authorised mass",
    B: "1,000kgs maximum authorised mass",
    C: "1,020kgs maximum authorised mass",
    D: "2,000kgs maximum authorised mass",
  },
  {
    question:
      "A vocational driver is required to hold a Driver Qualification Card following completion of 35 hours DCPC training. How long is this card valid for?",
    A: "1 year",
    B: "3 years",
    C: "5 years",
    D: "7 years",
  },
  {
    question: "When should wheel nuts be checked?",
    A: "Soon after a tyre has been changed",
    B: "After driving down a steep hill",
    C: "After a motorway journey",
    D: "Soon after unloading the vehicle",
  },
  {
    question:
      "After what age do vocational licence holders need to submit a medical form (D4) to renew their vocational entitlements?",
    A: "40 years of age",
    B: "45 years of age",
    C: "60 years of age",
    D: "65 years of age",
  },
  {
    question:
      "You are driving on a motorway. Your lorry has a gross vehicle weight in excess of 7,500kgs. What does this temporary sign mean to you?",
    A: "You must not use the right-hand lane",
    B: "You can only use the middle or right-hand lane",
    C: "You can’t leave the motorway at this junction",
    D: "You can only use the right-hand lane",
    imgSrc: "../../../../images/driving_assessments/driver_Q11.PNG",
  },
  {
    question: "What does this warning light on the dash mean?",
    A: "Low oil pressure",
    B: "Battery discharge",
    C: "Door open",
    D: "Braking system fault",
    imgSrc: "../../../../images/driving_assessments/driver_Q12.PNG",
  },
  {
    question:
      "You are driving a vehicle with a gross vehicle weight of 26 tonnes on a dual carriageway in England. What does this sign mean?",
    A: "A maximum speed of 60mph",
    B: "A maximum speed of 50mph",
    C: "A maximum speed of 40mph",
    D: "A maximum speed of 30mph",
    imgSrc: "../../../../images/driving_assessments/nonHGV_Q13.PNG",
  },
  {
    question:
      "You’re driving the vehicle on a motorway. What should you do when visibility is reduced by heavy rain?",
    A: "Double your dry weather separation distance",
    B: "Maintain a constant speed",
    C: "Drive with your headlamps on main beam",
    D: "Stay in the left-hand lane",
  },
  {
    question:
      "Which of the following can suspend a driver’s vocational entitlement on disciplinary grounds?",
    A: "Traffic Commissioner",
    B: "Driver Vehicle Standards Agency",
    C: "JAUPT",
    D: "Driver Vehicle Licencing Agency",
  },
  {
    customQuestionComponent: listQuestion(
      "Which of the following health and safety responsibilities apply to the agency driver?",
      [
        "1 Take reasonable care of themselves and others",
        "2 To report hazards or defects",
        "3 Co-operate with the operator on health and safety",
        "4 Use personal protective equipment as required",
      ],
      "",
      true
    ),
    A: "4 only",
    B: "1, 2, 3 and 4",
    C: "2, and 3 only",
    D: "1 only",
  },
  {
    question:
      "The colour and shape of a site warning sign is, according to the regulations:",
    A: "Red Circle",
    B: "Orange – four sided",
    C: "Yellow – three sided",
    D: "Blue – three sided",
  },
  {
    question: "What does this road marking mean?",
    A: "No loading or unloading at any time",
    B: "Loading and unloading is permitted at specified times",
    C: "No parking or waiting at any time",
    D: "Parking or waiting is permitted at specified times",
    imgSrc: "../../../../images/driving_assessments/driver_Q18.PNG",
    largeImage: true,
  },
];

const DrivingAssessment = ({
  setDriverAssesmentSubmitted,
  setDriverAssesmentPassed,
}) => {
  return (
    <AssessmentCreator
      questions={questions}
      submittedFlagFunc={setDriverAssesmentSubmitted}
      passedFlagFunc={setDriverAssesmentPassed}
      passMark={21}
      assessmentName="driverAsessement"
      retakeLink="driver-assessment"
      testTitle="HGV Driver Assessment"
    />
  );
};

DrivingAssessment.propTypes = {
  setDriverAssesmentSubmitted: func.isRequired,
  setDriverAssesmentPassed: func.isRequired,
};

const mapDispatchToProps = {
  setDriverAssesmentSubmitted: driverAssessmentSubmitted,
  setDriverAssesmentPassed: driverAssessmentPassed,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(DrivingAssessment);
